// extracted by mini-css-extract-plugin
export default {"body":"loading_body__IGNSQ","container":"loading_container__3sRJM","scale":"loading_scale__bFZNV","loader":"loading_loader__u5oGK","rotate":"loading_rotate__u4myS"};